<template>
  <b-card class="mb-4" no-header>
    <b-row>
      <b-col cols="12">
        <div class="d-flex mb-3">
          <b-button-group class="add-button-group">
          <b-btn variant="primary" to="/stock-ins/create">Tambah Stok Masuk</b-btn>
          </b-button-group>
          <div class="ml-auto" v-if="$store.getters['account/accountData'].role === Roles.ADMIN">
            <b-form-checkbox id="checkbox-trash" v-model="filter.with_trash" name="checkbox-trash" :value="1" :unchecked-value="null">
            Lihat Data Terhapus
            </b-form-checkbox>
          </div>
        </div>
      </b-col>
      <b-col cols="12" class="mb-4">
        <b-form @submit.prevent="doFilter">
          <b-row class="filter-row">
            <b-col cols="12" md="4">
              <form-group-input ref="filter-transaction_no" type="text" placeholder="" :need-label="true" label="no. dokumen" v-model="filter.transaction_no" id="filter-transaction_no" @keyup="filterTransactionNo" />
            </b-col>
            <b-col cols="12" md="4">
              <form-group-input ref="filter-tanggal_masuk" type="date" placeholder="" :need-label="true" label="tgl masuk" v-model="filter.tanggal_masuk" id="filter-tanggal_masuk" />
            </b-col>
            <b-col cols="12" md="4">
              <form-group-input ref="filter-approval_status" type="enum" placeholder="" :need-label="true" label="status" v-model="filter.approval_status" id="filter-approval_status" :options="[
                { value: 'draft', text: 'Draft' },
                { value: 'pending', text: 'On Review' },
                { value: 'approved', text: 'Disetujui' },
                { value: 'rejected', text: 'Ditolak' },
              ]" />
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
    <paginated-table ref="dataTable" :delete-reason="false" :can-delete="true" :can-edit="false" :delete-criteria="{ column: 'approval_status', criteria: '===', value: 'draft' }" :data-url="apiUrl" :data-columns="columns" :dataParams="dataParams" :defaultDataParams="this.filter">
      <template slot="content_approval_status" slot-scope="scope">
        <b-badge :variant="statusVariant(scope.colData.approval_status)">{{ statusLabel(scope.colData.approval_status) }}</b-badge>
      </template>
    </paginated-table>
  </b-card>
</template>

<script>
import { Roles, debounce } from '@/_helpers'
import paginatedTable from '@/components/PaginatedTable.vue'
import formGroupInput from '@/components/FormGroupInput.vue'
import StockIn from '@/models/StockIn.js'

const stockInModel = new StockIn()

export default {
  components: { paginatedTable, formGroupInput },
  data () {
    return {
      Roles: Roles,
      apiUrl: stockInModel.endpoint,
      columns: [
        {
          prop: 'transaction_no',
          label: 'No. Dokumen',
          deletedDetailHere: true,
          sortable: true,
          resizable: true,
          minWidth: 150,
          wrapInLink: true,
        },
        {
          prop: 'tanggal_masuk',
          label: 'Tanggal',
          align: 'center',
          formatThisDate: true,
          resizable: true,
          sortable: true,
          minWidth: 110,
        },
        {
          prop: 'sumber',
          label: 'Sumber',
          resizable: true,
          minWidth: 130,
          align: 'left',
        },
        {
          prop: 'approval_status',
          label: 'Status',
          hasCustomSlot: true,
          resizable: true,
          minWidth: 160,
          align: 'center',
        },
      ],
      filter: {
        with_trash: typeof this.$route.query.with_trash !== 'undefined' ? parseInt(this.$route.query.with_trash) : null,
        transaction_no: typeof this.$route.query.transaction_no !== 'undefined' ? this.$route.query.transaction_no : null,
        tanggal_masuk: typeof this.$route.query.tanggal_masuk !== 'undefined' ? this.$route.query.tanggal_masuk : null,
        approval_status: typeof this.$route.query.approval_status !== 'undefined' ? this.$route.query.approval_status : null,
      },
      dataParams: ['transaction_no', 'with_trash', 'tanggal_masuk', 'approval_status']
    }
  },
  beforeMount () {
    this.$router.push({query: {...this.$route.query}}).catch(() => {})
  },
  watch: {
    'filter.with_trash': function () {
      this.doFilter()
    },
    'filter.tanggal_masuk': function () {
      this.doFilter()
    },
    'filter.approval_status': function () {
      this.doFilter()
    },
  },
  methods: {
    filterTransactionNo () {
      this.debounceFilter(this)
    },
    debounceFilter: debounce((vm) => {
      vm.doFilter()
    }, 350),
    doFilter () {
      this.$refs.dataTable.doFilter(this.filter)
    },
    statusLabel (status) {
      return { draft: 'Draft', pending: 'On Review', approved: 'Disetujui', rejected: 'Ditolak' }[status] || status
    },
    statusVariant (status) {
      return { draft: 'secondary', pending: 'warning', approved: 'success', rejected: 'danger' }[status] || 'secondary'
    }
  }
}
</script>
